var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-schedule"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "schedule",
    clipPath: "url(#clip-schedule)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(-43.703 -616.231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "translate(44.704 617.231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M79.933,640.066v-16.43a3.205,3.205,0,0,0-3.2-3.2h-4.8v-2.4a.8.8,0,1,0-1.6,0v2.4H55.913v-2.4a.8.8,0,1,0-1.6,0v2.4H47.907a3.206,3.206,0,0,0-3.2,3.2v25.621a3.207,3.207,0,0,0,3.2,3.2H67.541a8.8,8.8,0,1,0,12.392-12.394Zm-33.628-16.43a1.6,1.6,0,0,1,1.6-1.6h6.405v1.6a1.6,1.6,0,1,0,1.6,1.6v-3.2H70.325v1.6a1.6,1.6,0,1,0,1.6,1.6v-3.2h4.8a1.6,1.6,0,0,1,1.6,1.6v4.8H46.305Zm1.6,27.222a1.6,1.6,0,0,1-1.6-1.6V630.042H78.332v8.978a8.791,8.791,0,0,0-11.837,11.839Zm26.422,3.2a7.206,7.206,0,1,1,7.206-7.206A7.214,7.214,0,0,1,74.328,654.061Z",
    transform: "translate(-44.704 -617.231)",
    fill: "#5c6d7e",
    stroke: "#5c6d7e",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M64.57,629.841l-5.039,5.039-1.836-1.836a.8.8,0,1,0-1.132,1.132l2.4,2.4a.8.8,0,0,0,1.132,0l5.6-5.6a.8.8,0,0,0-1.132-1.132Z",
    transform: "translate(-31.508 -603.185)",
    fill: "#5c6d7e",
    stroke: "#5c6d7e",
    strokeWidth: 0.8
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.c542462d2ea285bb7d1791125c345e0a.svg";
export { ForwardRef as ReactComponent };